"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MentoringRole = void 0;
var MentoringRole;
(function (MentoringRole) {
    MentoringRole["Mentor"] = "mentor";
    MentoringRole["Mentee"] = "mentee";
    MentoringRole["Peer"] = "peer";
})(MentoringRole = exports.MentoringRole || (exports.MentoringRole = {}));
